import { render, staticRenderFns } from "./BcFileUpload.vue?vue&type=template&id=4e5928c3&scoped=true"
import script from "./BcFileUpload.vue?vue&type=script&lang=js"
export * from "./BcFileUpload.vue?vue&type=script&lang=js"
import style0 from "./BcFileUpload.vue?vue&type=style&index=0&id=4e5928c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5928c3",
  null
  
)

export default component.exports